import { Controller } from "@hotwired/stimulus";

export class RootModalController extends Controller {
  openModal(event) {
    const modalElement = document.getElementById('modalOverlay');
    modalElement.hidden = false;
    event.preventDefault();
    modalElement.addEventListener('click', this.clickHandler.bind(this));
  }

  closeModal() {
    const modalElement = document.getElementById('modalOverlay');
    modalElement.removeEventListener('click', this.clickHandler.bind(this));
    modalElement.hidden = true;
  }

  clickHandler(event) {
    // モーダルの外側クリック時にモーダルを閉じる
    if (event.target.id === 'modalOverlay') {
      this.closeModal();
    }
  }
}
